//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectGoodModal from './components/select-good-modal';

export default {
    name: 'hotGoods',
    components: { SelectGoodModal },
    data() {
        var vm = this;
        return {
            loading: false,
            saving: false,
            hotGood: {},
            pageSize: 10,
            currentPage: 1,
            list: [],
            columns: [
                {
                    type: 'index', width: 60, align: 'center'
                },
                {
                    title: '商品名称', align: 'center', key: 'good.goodName',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.goodInfo(row.good);
                                }
                            }
                        }, row.good.goodName));
                        return h('div', actions);
                    }
                },
                {
                    title: '总库存', align: 'center', key: 'totalInventory',
                    render: (h, params) => {
                        return h('span', params.row.good.totalInventory);
                    }
                },
                {
                    title: '排序',
                    align: 'center',
                    key: 'sort'
                },
                {
                    title: '操作', align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        var edit = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.editHotGood(params.row);
                                }
                            }
                        }, '编辑');

                        var del = h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.delHotGood(params.row);
                                }
                            }
                        }, '删除');

                        if (vm.hasPermission('Pages.ShoppingMallManage.HotGoods.Edit')) {
                            actions.push(edit);
                        }
                        if (vm.hasPermission('Pages.ShoppingMallManage.HotGoods.Delete')) {
                            actions.push(del);
                        }
                        return h('div', actions);
                    }
                }
            ],
            totalCount: 0,
            searchInput: {},
            showHotGoodEditModal: false,
            rules: {
                goodName: [{ required: true, message: '请选择商品', trigger: 'blur' }]
            },
            showAddGoodModal: false,
            title: '新增推荐商品'
        };
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.pageSize = pagesize;
            this.getPage();
        },
        getPage() {
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.loading = true;
            abp.ajax.post('/api/services/app/Good/SearchHotGoods', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        editHotGood(hot) {
            if (hot.id > 0) {
                this.title = '编辑商品推荐';
            }
            this.hotGood = {};
            this.hotGood = hot;
            this.showHotGoodEditModal = true;
        },
        cancel() {
            this.showHotGoodEditModal = false;
        },
        onSave() {
            this.$refs.hotGoodForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/Good/SaveHotGood', this.hotGood).then(res => {
                        this.loading = false;
                        this.showHotGoodEditModal = false;
                        this.getPage();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        showAddGood() {
            this.showAddGoodModal = true;
        },
        addGood(good) {
            this.hotGood.goodName = good.goodName;
            this.hotGood.goodId = good.id;
            this.showAddGoodModal = false;
        },
        goodInfo(good) {
            this.$router.push({
                path: '/goodInfo/' + good.id
            });
        },
        delHotGood(hotGood) {
            this.$Modal.confirm({
                title: '删除确认',
                content: '您确定要删除该条推荐吗？',
                onOk: () => {
                    this.delete(hotGood);
                },
                onCancel: () => {
                }
            });
        },
        delete(g) {
            abp.ajax.delete('/api/services/app/Good/DeleteHotGoodById?id=' + g.id).then(res => {
                this.getPage();
            }).finally(() => {

            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getPage();
    }
};
